<template>
  <div class="platforms-settings">
    <popup :title="$t('view.settings.popup.deleteToken.title')" ref="tokenDelDialog">
      <p>{{ $t('view.settings.popup.deleteToken.text') }}</p>
      <template v-slot:buttons>
        <btn icon="times" @click="$refs.tokenDelDialog.close()">{{ $t('btn.cancel') }}</btn>
        <btn
          icon="trash"
          @click=" deleteToken(tokenToDel.id, tokenToDel.index)"
          color="red"
        >{{ $t('btn.delete') }}</btn>
      </template>
    </popup>

    <section-title>{{ $t('view.settings.platform.platformsTitle') }}</section-title>
    <section-title subsection>{{ $t('view.settings.platform.messengerTitle') }}</section-title>
    <div class="platforms-settings__section platforms-settings__basic-section editor-section">
      <div
        class="editor-section-description"
      >{{ $t('view.settings.platform.messengerDescription') }}</div>
      <div class="editor-section platforms-settings__messenger">
        <sw-button :label="$t('common.enabled')" v-model="platforms.messenger.messengerEnabled"></sw-button>
      </div>
      <btn
        class="platforms-settings__save-button"
        icon="save"
        @click="saveMessenger"
      >{{ $t('btn.save') }}</btn>
    </div>

    <section-title subsection>{{ $t('view.settings.platform.webTitle') }}</section-title>
    <div class="platforms-settings__section platforms-settings__basic-section editor-section">
      <div class="editor-section-description">{{ $t('view.settings.platform.webDescription') }}</div>
      <div class="editor-section platforms-settings__web">
        <sw-button :label="$t('common.enabled')" v-model="platforms.web.webchatEnabled"></sw-button>
      </div>
      <btn class="platforms-settings__save-button" icon="save" @click="saveWeb">{{ $t('btn.save') }}</btn>
      <div
        class="platforms-settings__header"
        style="margin-top: 50px;"
      >{{ $t('view.settings.platform.webTokensTitle') }}</div>
      <div class="platforms-settings__webtokens">
        <div class="platforms-settings__tokens-list">
          <div
            v-for="(token, index) in webchatTokens"
            :key="index"
            class="platforms-settings__token-row"
          >
            <div class="platforms-settings__token">
              <div class="platforms-settings__token-text">{{ token.token }}</div>
              <div class="platforms-settings__token-more">
                <sw-button v-model="token.active" @input="toggleTokenState(token.id, $event)"></sw-button>
                <fai
                  class="platforms-settings__token-icon"
                  icon="times"
                  @click="openTokenDeleteDialog(token.id, index)"
                ></fai>
              </div>
            </div>

            <div class="platforms-settings__token-domains">
              <div
                v-for="(domain, index2) in token.domains"
                :key="domain.id"
                class="platforms-settings__token-domain"
              >
                <div>
                  <input
                    type="text"
                    v-model="domain.domain"
                    class="platforms-settings__token-domain-input"
                    @keydown.enter="$event.target.blur()"
                    @blur="updateDomain(domain.domain, domain.id)"
                  >
                </div>
                <div class="platforms-settings__token-domain-icons">
                  <fai icon="times" @click="deleteDomain(index, index2)"></fai>
                </div>
              </div>
              <div class="platforms-settings__token-domain">
                <div>
                  <input
                    type="text"
                    placeholder="https://your-adress.com"
                    class="platforms-settings__token-domain-input"
                    @keydown.enter="$event.target.blur()"
                    @blur="createDomain($event.target.value, index)"
                    ref="newDomainInput"
                  >
                </div>
              </div>
              <!-- <div
                class="platforms-settings__token-domain platforms-settings__token-domain--center"
              >
                <div
                  class="platforms-settings__token-domain-add"
                  @click="createDomain"
                >{{ $t('view.settings.platform.addDomain') }}</div>
              </div>-->
            </div>
          </div>
        </div>
        <div
          @click="createNewToken"
          class="platforms-settings__add-token"
        >{{ $t('view.settings.platform.addToken') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import axios from '@/axios'
export default {
  data() {
    return {
      platforms: {
        messenger: {
          messengerEnabled: null
        },
        web: {
          webchatEnabled: null
        }
      },
      webchatTokens: [],
      tokenToDel: {
        id: null,
        index: null
      }
    }
  },

  async created() {
    try {
      const messengerSettingsReq = await axios.get('/api/platforms/messenger')
      const webchatSettingsReq = await axios.get('/api/platforms/webchat')
      await this.fetchTokens()
      this.platforms.messenger = messengerSettingsReq.data.settings
      this.platforms.web = webchatSettingsReq.data.settings
    } catch (e) {
      this.notify('error', 'view.settings.error.load')
      console.error(e)
    }
  },

  methods: {
    async fetchTokens() {
      try {
        const data = (await axios.get('/api/platforms/webchat/tokens')).data.tokens
        let i = 0
        const tokens = []
        while (i < data.length) {
          let token = {
            id: data[i].tokenId,
            active: data[i].active,
            token: data[i].token,
            domains: []
          }
          let noData = true
          while (i < data.length && token.id === data[i].token_id) {
            noData = false
            token.domains.push({
              id: data[i].id,
              domain: data[i].domain
            })
            i++
          }
          tokens.push(token)
          if (noData) i++
        }
        this.webchatTokens = tokens
      } catch (e) {
        return e
      }
    },

    async saveMessenger() {
      try {
        await axios.put('/api/platforms/messenger', this.platforms.messenger)
        this.notify('success', 'view.settings.success.messengerSettings')
      } catch (e) {
        console.error(e)
        this.notify('error', 'view.settings.error.messengerSettings')
      }
    },

    async saveWeb() {
      try {
        await axios.put('/api/platforms/webchat', this.platforms.web)
        this.notify('success', 'view.settings.success.webSettings')
      } catch (e) {
        console.error(e)
        this.notify('error', 'view.settings.error.webSettings')
      }
    },

    async toggleTokenState(id, state) {
      try {
        await axios.put('/api/platforms/webchat/token', {
          id,
          active: state
        })
        this.notify('success', 'view.settings.success.tokenEdit')
      } catch (e) {
        this.notify('success', 'view.settings.error.tokenEdit')
      }
    },

    async createNewToken() {
      try {
        const tokenReq = await axios.post('/api/platforms/webchat/token')
        const token = tokenReq.data
        token.domains = []
        this.webchatTokens.push(token)
        this.notify('success', 'view.settings.success.tokenCreation')
      } catch (e) {
        this.notify('error', 'view.settings.error.tokenCreation')
      }
    },

    async deleteToken(id, index) {
      try {
        await axios.delete('/api/platforms/webchat/token', {
          data: {
            id
          }
        })
        this.webchatTokens.splice(index, 1)
        this.notify('success', 'view.settings.success.tokenDelete')
        this.$refs.tokenDelDialog.close()
      } catch (e) {
        this.notify('error', 'view.settings.error.tokenDelete')
      }
    },

    async createDomain(value, index) {
      try {
        if (!this.validateDomain(value)) {
          this.notify('error', 'view.settings.error.domainInvalid')
          return
        }

        const actToken = this.webchatTokens[index]

        const res = await axios.post('/api/platforms/webchat/token/domain', {
          token_id: actToken.id,
          domain: value
        })

        this.webchatTokens[index].domains.push({
          id: res.data,
          domain: value,
          token_id: actToken.id
        })
        this.$refs.newDomainInput[index].value = ''
        this.notify('success', 'view.settings.success.domainCreation')
      } catch (e) {
        this.notify('error', 'view.settings.error.domainCreation')
      }
    },

    async updateDomain(value, id) {
      try {
        if (!this.validateDomain(value)) {
          this.notify('error', 'view.settings.error.domainInvalid')
          return
        }

        const res = await axios.put('/api/platforms/webchat/token/domain', {
          id,
          newDomain: value
        })
        this.notify('success', 'view.settings.success.domainEdit')
      } catch (e) {
        this.notify('error', 'view.settings.error.domainEdit')
      }
    },

    async deleteDomain(index, index2) {
      try {
        const res = await axios.delete('/api/platforms/webchat/token/domain', {
          data: {
            domainId: this.webchatTokens[index].domains[index2].id          }
        })

        this.webchatTokens[index].domains.splice(index2, 1)
        this.notify('success', 'view.settings.success.domainDelete')
      } catch (e) {
        this.notify('error', 'view.settings.error.domainDelete')
      }
    },

    validateDomain(text) {
      const regex = /^https?:\/\/([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/
      if (regex.test(text)) return true
      return false
    },

    openTokenDeleteDialog(id, index) {
      this.$refs.tokenDelDialog.open()
      this.tokenToDel.id = id
      this.tokenToDel.index = index
    }
  }
}
</script>

<style lang="scss">
.platforms-settings {
  &__section {
    margin-bottom: 80px;
    position: relative;
    width: 34vw;
    min-width: 540px;
  }

  &__save-button {
    position: absolute;
    right: 0;
  }

  &__messenger {
    @include alignedFlex(flex-start);
    position: relative;
    align-items: flex-start;
    margin-bottom: 25px;
    width: 44vw;
    min-width: 500px;
  }

  &__header {
    font-size: 1.05em;
    letter-spacing: 0.05em;
    color: $borderGrey;
    text-transform: uppercase;
    color: rgba(162, 15, 50, 0.36);
    font-weight: 700;
    margin-bottom: 15px;
  }

  &__webtokens {
    padding-bottom: 15px;
  }

  &__add-token {
    @include clickableText();
    margin-top: 25px;
    text-align: left;
  }

  &__tokens-list {
  }

  &__token-row {
    margin-bottom: 10px;
  }

  &__token {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    font-size: 1.1em;
    padding: 8px 10px;
  }

  &__token-icon {
    cursor: pointer;
    transition: color 0.2s ease;
    color: #cccccc;
    &:hover {
      color: #a5a5a5;
    }
  }

  &__token-more {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(162, 15, 50, 0.36);
    width: 70px;
  }

  &__token-domains {
    background-color: $bgLightGrey;
  }

  &__token-domain {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 10px 7px 18px;
    font-weight: 300;

    &--center {
      justify-content: center;
    }

    &:not(:last-of-type) {
      border-bottom: 1px solid $borderGrey;
    }
  }

  &__token-domain-add {
    @include clickableText();
    margin: 0;
  }

  &__token-domain-icons {
    color: #cccccc;
    font-size: 1.1em;

    & > * {
      transition: color 0.2s ease;
      margin: 0 4px;
      cursor: pointer;

      &:hover {
        color: #a5a5a5;
      }
    }
  }

  &__token-domain-input {
    font-size: 0.95em;
    font-weight: 300;
    outline: none;
    border: none;
    background: transparent;
    width: 250px;
  }
}
</style>
